/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/shelfList.config.json";
import sample_config from "../config/shelf.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_SHELF_LIST } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { capitalCase } from "change-case";
import { StorageModule } from "@vlinder-web/storage-module-react";

const log: any = LoggerModule?.getInstance();
const storageSrv = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IShelfListMethods extends IPluginMethodMap {
  getShelfList(args: any): Promise<any>;
}

export class ShelfListService implements IAgentPlugin {
  readonly methods: IShelfListMethods;

  constructor() {
    this.methods = {
      getShelfList: this.getShelfList.bind(this),
    };
  }

  async getShelfList(args: any) {
    log.blue(`getShelfList server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      // return {...config}
      if (client) {
        const res = await client.query({
          query: GET_SHELF_LIST,
          variables: {
            options: {
              limit: args?.size ?? 10,
              skip: args?.offset ?? 0,
            },
            filter: {
              ...args?.criteria,
              band__in: [
                storageSrv?.get("currencyExchangeLocal", "local")?.bandId ??
                  null,
              ],
            },
            getDistCentsFilter: {
              band__in: [
                storageSrv?.get("currencyExchangeLocal", "local")?.bandId ??
                  null,
              ],
            },
          },
          fetchPolicy: "network-only",
        });
        // const res: any = sample_config;
        if (res?.data) {
          let _totalPages = res?.data?.getShelves?.count
            ? parseInt(res?.data?.getShelves?.count) / 10
            : 1;
          let _currentPage =
            res?.data?.getShelves?.skip / res?.data?.getShelves?.limit + 1;
          return {
            ...config,
            band: {
              name:
                storageSrv.get("currencyExchangeLocal", "local")?.band ?? null,
              id:
                storageSrv?.get("currencyExchangeLocal", "local")?.bandId ??
                null,
            },
            isEmpty: res?.data?.getShelves?.content?.length <= 0,
            ultUsers: this._getSehlfData(res?.data?.getShelves?.content),
            activePage: _currentPage,
            pageSize: res?.data?.getShelves?.limit,
            totalCount: res?.data?.getShelves?.count,
            totalPages: _totalPages,
            distCenters: this._getDistCenters(res?.data?.getDistCents?.content),
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private _getSehlfData = (data: any) => {
    let _res: any[] = [];
    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any, index: number) => {
        console.log("item===>", item);
        _res.push({
          id: item?._id,
          shelfId: item?.shelfId,
          name: item?.name,
          activeStatus: item?.activeStatus,
          boxesCount:
            item?.undeliveredBoxesCount !== null &&
            item?.undeliveredBoxesCount > 0
              ? item?.undeliveredBoxesCount
              : 0,
          distName: item?.distCent?.name,
          deliveryStatus: item?.shelfDeliveryStatus,
          dateCreated: item?.createdAt
            ? this.formatCreatedDate(item?.createdAt)
            : "",
        });
      });
    console.log(`_getShelfData : `, _res);
    return _res;
  };

  private _getDistCenters = (data: any) => {
    let _res: any = [];
    if (data && Array.isArray(data) && data.length > 0) {
      if (data && data.length > 1) {
        _res.push({
          label: "Select",
          value: "null",
          key: 0,
        });
      }
      data.map((item: any, index: number) => {
        _res.push({
          label: item?.name ? capitalCase(item?.name) : item?.distCenterId,
          value: item?.id,
          key: index + 1,
        });
      });
    }
    return _res;
  };

  private formatCreatedDate(date: Date) {
    const eventTimeZone = storageSrv.get(
      "currencyExchangeLocal",
      "local"
    )?.eventTimeZone;
    console.log(`metaData`, eventTimeZone);
    if (date && eventTimeZone) {
      let _date = `${moment.tz(date, eventTimeZone?.tmz).format("LLL")} ${
        eventTimeZone?.abbrevation
      }`;
      console.log(`_date`, _date);
      return _date;
    }
  }

  private getFormattedStatus(status: string, suspended: boolean) {
    if (suspended) {
      return "suspended";
    } else {
      switch (status) {
        case "USER_ADDED":
          return "created";
        case "INVITED":
          return "invited";
        case "EMAIL_VERIFIED":
          return "verified";
        case "ACC_CREATED":
          return "active";
        case "WALLET_REGISTERED":
          return "active";
        case "SUSPENDED":
          return "suspended";
        default:
          return "-";
      }
    }
  }
}
